export default class productInnerCtrl {
    constructor($scope, $http, $rootScope, $compile, bsLoadingOverlayService, $timeout) {
        'ngInject';

        //Product Info
        $scope.product = {};

        //All Variants
        $scope.variants = {};

        //Current Variant
        $scope.variant = {};
        $scope.manageButtons = '';
        $scope.addToCartQTY = 1;
        $scope.addingToCart = false;
        //Select variant on dropdown
        $scope.selectVariant = function (varid) {

            try {
                $scope.variant = {};
                $scope.variant = $scope.variants[varid];
                $scope.variant.variantid = varid;
                $rootScope.gvariantid = varid;

                $scope.addToCartQTY = 1;

                // if (!$scope.$$phase) {
                //     //$digest or $apply
                //     $scope.$apply();
                //     //$scope.$digest();
                // }
                // $("#product-image-wrap").load("/ajax/product-inner-gallery.php?id=" + varid);

                // $http({
                //     method: "GET",
                //     url: "?_format=json&raw=true",
                // }).then(function (data) {
                //     var varid = $scope.variant.variantid;
                //     $scope.variants = data.data.variants;
                //     $scope.variant = $scope.variants[varid];
                //     $scope.variant.variantid = varid;
                //     $scope.getCurrentVariants();
                // });
            } catch (e) {

            }

        };

        // Increase the qty to be added to cart
        $scope.manageQty = function (action) {

            if (action == 'increase') {
                if ($scope.variant.qty > $scope.addToCartQTY) $scope.addToCartQTY++;

            } else {
                if ($scope.addToCartQTY > 1) {
                    $scope.addToCartQTY--;
                }
            }
        }

        $scope.notify = function (show) {
            $scope.addingToCart = show;
        }

        //Add To Cart
        $scope.addToCart = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            if (!$scope.variant.id) {
                $(".select2").addClass("error");
                //Show select variant msg
                // $rootScope.displayMessage("selectSize", true);
                //hide it after 3 secs
                setTimeout(function () {
                    // $rootScope.displayMessage("selectSize", false);
                }, 3000);
                return false;
            }

            $(".select2").removeClass("error");
            if ($scope.variant.qty <= 0) {
                // $rootScope.displayMessage("outOfStock", true);
                return false;
            }

            $(".add-to-cart").addClass("loading");

            $http({
                method: "POST",
                url: "/en/cart/additem",
                data: $rootScope.params({
                    variant_id: $scope.variant.id,
                    product_id: $scope.product.pid,
                    qty: $scope.addToCartQTY
                }),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            }).then(function success(successData) {
                var data = successData.data;
                if (data.status) {
                    $rootScope.session.order.cart = data.cart;
                    $rootScope.session.order.cart.summary.total_items = data.cart.totals.total_items;
                    // $rootScope.displayMessage("addedToCart", true);

                    $scope.notify(true);

                    try {
                        //Events
                        fbq('track', 'AddToCart', {
                            content_name: $scope.product.title,
                            content_category: '',
                            content_ids: [$scope.variant.id],
                            content_type: 'product',
                            value: $scope.variant.price,
                            currency: 'GBP'
                        });
                    } catch (error) {
                        
                    }

                    $timeout(function () {
                        $scope.notify(false);
                    }, 5000);

                    try {
                        
                        var payload = {
                            "event": "add_to_cart",
                            currency: "EUR",
                            value: $scope.product.Variant.price,
                            items: [{
                              item_id: $scope.product.pid,
                              item_name: $scope.product.title,
                              currency: "EUR",
                              index: 0,
                              item_brand: 'Pentheroudakis',
                              item_category: $scope.product.byCategoryTxt,
                              price: $scope.product.Variant.price,
                              quantity: 1,
                              
                            }]
                          }
                          dataLayer.push(payload);

                    } catch (error) {
                        console.log('Datalayer Error: ', error);
                    }
                }
                $(".add-to-cart").removeClass("loading");
                $rootScope.$broadcast('getCart', {
                    forceFetch: 1
                });
                // $scope.getCurrentVariants();
            }, function error(errorData) {
                console.log('Error: ', errorData);
            })

        };

        $scope.optionCompile = function(html){
            return $compile(html)($scope);
        };
        // $scope.inWishList = function () {
        //     var wl = {};
        //     var vrnt = {};
        //     wl = $rootScope.session.order.wishlist.ids;

        //     vrnt = $scope.variant.variantid;
        //     return wl.indexOf(vrnt);
        // };

        $scope.isOutOfStock = function (variant) {
            var iioos = false;
            try{
                iioos = iioos || ( variant.qty == 0 );

                // Check if cart has quantities of this variant
                angular.forEach($rootScope.session.order.cart.items, function(item, i){
                    if( item.item_id == variant.id ){
                        iioos = ( item.quantity - variant.qty ) == 0;
                    }
                });

                
            }catch(e){
                iioos = false;
            }
            return iioos;
        }

        $scope.areOutOfStock = function (variants) {
            var iioos = true;
            
            try{
                angular.forEach(variants, function(item, i){
                    iioos = iioos && $scope.isOutOfStock(item);
                });
            }catch(e){
                iioos = false;
            }
            return iioos;
        }

        $scope.checkStock = function(variant){
            try{
                var qtyInStock = variant.qty;
                // Check if cart has quantities of this variant
                angular.forEach($rootScope.session.order.cart.items, function(item, i){
                    if( item.item_id == variant.id ){
                        qtyInStock = qtyInStock - item.quantity;
                    }
                });
            }catch(e){ }
            return qtyInStock;
        }

        //Product images slick sliders
        $scope.initSliders = function () {
            try {
                $("#product-slider").slick("unslick");
                $("#product-carousel").slick("unslick");
            } catch (e) {}
            productSlider();
        };

        $scope.displayMessage = function (msgNumber, showError) {
            var elem = $(".msg-" + msgNumber);
            if (showError) {
                if (elem.is(":hidden")) {
                    elem.fadeIn("fast");
                } else {
                    animateElement(elem);
                }
            } else {
                elem.fadeOut("fast");
            }
        };

        // $scope.addTowishlist = function ($event, _varId, _prodId) {
        //     $event.stopPropagation();
        //     $event.preventDefault();
        //     if ($rootScope.session.order.wishlist.hasOwnProperty('ids') == false) {
        //         return false;
        //     }
        //     bsLoadingOverlayService.start();
        //     if ($rootScope.session.order.wishlist.ids.indexOf(_varId) > -1) {
        //         $.ajax({
        //             url: "/actions.php",
        //             data: $rootScope.params({
        //                 action: 'removefromwishlist',
        //                 variantid: _varId
        //             }),
        //             dataType: "json",
        //             success: function (result) {
        //                 $rootScope.getUserWishlist();
        //                 setTimeout(function () {
        //                     bsLoadingOverlayService.stop();
        //                 }, 600);
        //             }
        //         });
        //         return false;
        //     }
        //     $.ajax({
        //         url: "/actions.php",
        //         data: $rootScope.params({
        //             action: 'addtowishlist',
        //             variantid: _varId,
        //             productid: _prodId
        //         }),
        //         dataType: "json",
        //         success: function (result) {
        //             $rootScope.getUserWishlist();
        //             setTimeout(function () {
        //                 bsLoadingOverlayService.stop();
        //             }, 600);
        //         }
        //     });
        // }
    }
}